import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { Sparkles } from 'lucide-react';
import './i18n';

// Layouts
import { Navbar, Footer } from './layouts';

// Pages
import {
  HomePage,
  ServicesPage,
  ServiceDetailPage,
  CoursesPage,
  CourseDetailPage,
  TeachersPage,
  TeacherDetailPage,
  SchoolsPage,
  SchoolDetailPage,
  KnowledgePage,
  ArticleDetailPage,
  LoginPage,
  RegisterPage,
  ProfilePage,
  AdminPage
} from './pages';

// Forms (from existing Forms.jsx)
import { BecomeTeacherForm, BecomeSchoolForm, CreateServiceForm, CreateCourseForm } from './components/Forms';
import { EditProfilePage } from './components/EditProfile';

function AppContent() {
  const { loadUser, isLoading } = useAuthStore();

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream" style={{ backgroundColor: '#FDFBF7' }}>
        <Sparkles className="h-12 w-12 text-gold animate-pulse" style={{ color: '#D4A574' }} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream" style={{ backgroundColor: '#FDFBF7' }}>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/service/:id" element={<ServiceDetailPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/course/:id" element={<CourseDetailPage />} />
          <Route path="/teachers" element={<TeachersPage />} />
          <Route path="/teacher/:id" element={<TeacherDetailPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/school/:id" element={<SchoolDetailPage />} />
          <Route path="/knowledge" element={<KnowledgePage />} />
          <Route path="/article/:id" element={<ArticleDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/edit" element={<EditProfilePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/become-teacher" element={<BecomeTeacherForm />} />
          <Route path="/become-school" element={<BecomeSchoolForm />} />
          <Route path="/create-service" element={<CreateServiceForm />} />
          <Route path="/create-course" element={<CreateCourseForm />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
